import config from "../../app.json";
import axios from "axios";

import { Context } from "../../Reducers/Store";
import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FieldText from "../../Components/Fields/FieldText";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";

import AlertComponent from "../../Components/AlertComponent";
import CsWhiteLogo from "../../Assets/Svgs/cs-white-logo.svg";
import AwsLogo from "../../Assets/Svgs/aws-logo.svg";

function Login() {
  const [state, dispatch] = useContext(Context);
  const [email, setEmail] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [password, setPassword] = useState(null);
  const [passwordError, setPasswordError] = useState(null);

  let location = useLocation();
  let navigate = useNavigate();
  let from = location.state?.from?.pathname || "/";

  const fetchProfile = (token) => {
    let configRequest = { headers: { Authorization: "Bearer " + token } };
    axios.post(config.API + "/api/user/getProfile", null, configRequest).then((res) => {
      axios.post(config.API + "/api/church/getBasicChurch", null, configRequest).then((resC) => {
        dispatch([
          { type: "SET_CHURCH", payload: resC.data },
          { type: "SET_LOGGED", payload: { jwt: token, profile: res.data } }
        ]);

        const uri = from || state?.defaultPath;
        navigate(uri, { replace: false });
      }).catch(function (error) {
        return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
      });
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (!email) setEmailError("E-mail is required");
    else if (!password) setPasswordError("Password is required");
    else {
      setEmailError(null);
      setPasswordError(null);

      axios.post(config.API + "/api/user/authenticate", { email, password }).then((res) => {
        if (res.status === 200) {
          fetchProfile(res.data.token);
        } else
          return AlertComponent("Error", res.statusText, { icon: `error` });
      }).catch(function (error) {
        return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
      });
    }
  };

  return (
    <div className="prelogin-container">
      <div className="containerLoginForm">
        <Row className="header-login">
          <Col className="col-md-6">
            <img className="cs-logo-login" src={CsWhiteLogo} />
          </Col>
          <Col className="col-md-6">
            <img className="aws-logo-login" src={AwsLogo} />
          </Col>
        </Row>
        <Row className="login-body">
          <Col className="col-md-7 cs-3d-phone">
            <iframe
              src="https://my.spline.design/untitled-c751e6b7fc77254e43fcafa257e796e6/"
              frameBorder="0"
              width="100%"
              height="100%"
            ></iframe>
          </Col>
          <Col className="col-md-5 cs-login-form">
            <h2>Welcome</h2>
            <form onSubmit={handleLogin} className="form-login">
              <Row>
                <Col className="col-md-12">
                  <FieldText
                    label="Email"
                    type="email"
                    onChange={(x) => setEmail(x.target.value)}
                    placeholder="Username"
                    value={email}
                    className="email-field"
                    error={emailError}
                    required={true}
                    inputClassName={`inputOption`}
                    autoComplete="off"
                  />
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <FieldText
                    label="Password"
                    type="password"
                    placeholder="Password"
                    onChange={(x) => setPassword(x.target.value)}
                    value={password}
                    className="password-field"
                    error={passwordError}
                    required={true}
                    inputClassName={`inputOption passwordInput`}
                    autoComplete="off"
                  />
                </Col>
              </Row>
              <div className="form-group mt-3 loginAlignCenter">
                <button type="submit" className="btn submitLogin col-md-12">
                  Sign In
                </button>
              </div>

              <div className="loginAlignCenter">
                <span className="signUpText">
                  Don't have an account?{" "}
                  <a
                    className="signUpLink"
                    onClick={() => navigate("/register", { replace: false })}
                  >
                    Sign Up
                  </a>
                </span>
              </div>

              <div className="loginAlignCenter">
                <span className="signUpText">
                  <a
                    className="signUpLink"
                    onClick={() =>
                      navigate("/recoverpassword", { replace: false })
                    }
                  >
                    Recover
                  </a>{" "}
                  Password
                </span>
              </div>
            </form>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Login;
